import { render, staticRenderFns } from "./terrain.vue?vue&type=template&id=3d22cc52&scoped=true&"
import script from "./terrain.vue?vue&type=script&lang=js&"
export * from "./terrain.vue?vue&type=script&lang=js&"
import style0 from "./terrain.vue?vue&type=style&index=0&id=3d22cc52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d22cc52",
  null
  
)

export default component.exports